import { Box, TextField } from '@mui/material';
import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';

import * as React from 'react';
import { serverImageUrl } from '../../util';

type Props = NodeViewProps;

export default function CustomImageWithOptions({
  node,
  updateAttributes,
}: Props) {
  const mediaId = node.attrs['mediaId'];
  const caption = node.attrs['caption'] || '';

  const handleCaptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateAttributes({ caption: event.target.value });
  };

  return (
    <NodeViewWrapper>
      <Box className="image-wrapper" sx={{ mb: 2, maxWidth: 300 }}>
        <Box
          component="img"
          src={
            mediaId ? serverImageUrl({ id: mediaId, w: 300 }) : node.attrs.src
          }
          alt={caption || ''}
          sx={{
            maxWidth: '100%',
            height: 'auto',
            display: 'block',
            mb: 1,
          }}
        />

        <TextField
          value={caption}
          onChange={handleCaptionChange}
          placeholder="Add a caption..."
          variant="outlined"
          size="small"
          fullWidth
          sx={{
            '& .MuiOutlinedInput-root': {
              fontSize: '0.875rem',
            },
          }}
        />
      </Box>
    </NodeViewWrapper>
  );
}
